import React from 'react';
import { string, shape } from 'prop-types';
import { Card, Paragraph, Link } from 'components/common';

import './ProviderPane.scss';

const ProviderPane = ({ providerName, providerImage, href }) => (
  <div className="provider-list-item">
    <Link to={href || '/'}>
      <Card className="provider-card" preserveShapeOnMobile>
        <div className="content-wrapper">
          <div className="provider-img">
            <img src={providerImage.url} alt={providerImage.alt} />
          </div>
          <Paragraph>
            <strong>
              <span className="provider-name">
                {providerName}
              </span>
            </strong>
          </Paragraph>
        </div>
      </Card>
    </Link>
  </div>
);

ProviderPane.propTypes = {
  providerName: string.isRequired,
  href: string.isRequired,
  providerImage: shape({
    url: string,
    alt: string,
  }).isRequired,
};

export default ProviderPane;
